import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isMobile: window.innerWidth < 1000,
};

const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		updateIsMobile: (state, action) => {
			state.isMobile = action.payload;
		},
	},
});

export const { updateIsMobile } = uiSlice.actions;
export default uiSlice.reducer;
